export default [
	{
		path: '/mall/home',
		name: 'mallHome',
		component: () => import('@/views/mall/home/index.vue'),
		meta: {
			title: '首页',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/category/:id',
		name: 'mallCategory',
		component: () => import('@/views/mall/category/index.vue'),
		meta: {
			title: '商品分类',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/product/:id',
		name: 'mallProductDetail',
		component: () => import('@/views/mall/product/index.vue'),
		meta: {
			title: '商品详情',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/cart',
		name: 'mallCart',
		component: () => import('@/views/mall/cart/index.vue'),
		meta: {
			title: '购物车',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/orders',
		name: 'mallOrders',
		component: () => import('@/views/mall/orders/index.vue'),
		meta: {
			title: '我的订单',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/profile',
		name: 'mallProfile',
		component: () => import('@/views/mall/profile/index.vue'),
		meta: {
			title: '个人中心',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/about',
		name: 'mallAbout',
		component: () => import('@/views/mall/about/index.vue'),
		meta: {
			title: '关于我们',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/news/:id',
		name: 'mallNewsDetail',
		component: () => import('@/views/mall/newsDetail/index.vue'),
		meta: {
			title: '文章详情',
			auth: false,
			keepAlive: false
		}
	},
	{
		path: '/mall/checkoutOrder',
		name: 'checkoutOrder',
		component: () => import('@/views/mall/checkoutOrder/index.vue'),
		meta: {
			title: '核对订单信息',
			auth: false,
			keepAlive: false
		}
	},
	// mall 根路径重定向
	{
		path: '/mall',
		redirect: '/mall/home'
	}
]
